import { render } from "./UpdateOrderModal.vue?vue&type=template&id=f72194bc&scoped=true"
import script from "./UpdateOrderModal.vue?vue&type=script&lang=js"
export * from "./UpdateOrderModal.vue?vue&type=script&lang=js"

import "./UpdateOrderModal.vue?vue&type=style&index=0&id=f72194bc&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f72194bc"]])

export default __exports__